(function($, Drupal, drupalSettings) {

  Drupal.behaviors.mbo_footer_001 = {
    attach: function (context, settings) {

      footerAccordion();

      $('.footer-menu-sur', context).once('footer-accordion').mbf_accordion( {
        accordionItem: '.footer-menu-sur',
        slideElement: '.footer-menu-list',
        icon: true,
        iconElement: '.footer-menu-sur',
        parentItem: '.footer-menu-sur',
        containerItem: '.footer-menus',
        maxWidth: 767,
      });

      $(window).resize(function() {
        footerAccordion();
      });

      function footerAccordion() {

        if ($(window).innerWidth() <= 767 && !$('.footer-menus').hasClass('hasAccordion')) {
          $('.footer-menu-list').css('display', 'none');
          $('.footer-menus').addClass('hasAccordion');
        } else if ($(window).innerWidth() > 767) {
          $('.footer-menu-list').css('display', 'inherit');
          $('.footer-menus').removeClass('hasAccordion');
          $('.footer-menu-sur').removeClass('open').removeClass('opened');
        }
      }

    }
  }; //Drupal.behaviors.mbo_footer_001

})(jQuery, Drupal, drupalSettings);
